import { InboxOutlined } from '@ant-design/icons';
import { message, Upload } from 'antd';
const { Dragger } = Upload;

export const DragAndDropFile = ({ onChange }) => (
    <Dragger
        multiple={true}
        beforeUpload={() => { return false; }}
        onChange={(info) => {
            const { status } = info.file;
            if (status !== 'uploading') {
                onChange('file', info.fileList);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        }}
        onDrop={(e) => {
            onChange('file', e.dataTransfer.files);
        }}>
        <p className="ant-upload-drag-icon">
            <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag file to this area to upload</p>
    </Dragger >
);